// Fixed list of usage action names (docs/refer/design/sessionhandling-v1.md § Logging): coarse
// names only, never free text. Pass one to userFetch(); the middleware logs it as an `action`
// event. Client-safe.

/** Header that marks a fetch as a real user action; its value is the action name. */
export const USER_ACTION_HEADER = "x-user-action";

export const USAGE_ACTIONS = {
  /** Any fetch started by a click / key press that has no explicit name (set by the fetch interceptor). */
  UI: "ui",
  ATTENDANCE_SAVE: "attendance.save",
  MARKS_SAVE: "marks.save",
  REPORT_CARDS_GENERATE: "report_cards.generate",
  FEE_PAYMENT_COLLECT: "fees.payment_collect",
  STUDENT_SAVE: "students.save",
  FAMILY_CREATE: "families.create",
  SESSION_END: "sessions.end",
  SESSION_END_USER: "sessions.end_user",
} as const;

export type UsageAction = (typeof USAGE_ACTIONS)[keyof typeof USAGE_ACTIONS];
